export default __webpack_public_path__ + "static/media/storageUnit1-afterB-480w.e400df07.png";